export default {
  slug: "kids-dentistry-in-guwahati",
  title: "Pediatric Dentistry in Guwahati",
  subtitle: "Kids’ Dentistry- Gentle Care for Growing Smiles",

  heroImage:
    "/dental-services/kids-dentistry/kids-dentist-in-guwahati.webp",

  sections: [
    {
      type: "text",
      heading: "Pediatric Dentistry at Magnum Dental Clinic, Guwahati",
      content: `
Kids dentistry, also known as pediatric dentistry, focuses on the oral health of infants, children, and adolescents. Early dental care is essential to ensure healthy teeth, proper jaw development, and positive dental habits for life.

At **Magnum Dental Clinic, Guwahati**, we provide gentle, friendly, and specialized dental care for children in a calm and comfortable environment. Our goal is to make every child feel safe, confident, and happy during their dental visits.
      `,
    },

    {
      type: "text",
      heading: "Why is Dental Care Important for Children?",
      content: `
Healthy baby teeth are essential for:

✔ Proper chewing and nutrition  
✔ Clear speech development  
✔ Guiding permanent teeth into correct positions  
✔ Maintaining facial structure  
✔ Preventing pain, infection, and future dental problems  

Early dental visits help detect issues early and reduce fear of dental treatment later in life.
      `,
    },

     {
      type: "image",
      images: [
        "/dental-services/kids-dentistry.webp",
        "/dental-services/kids-dentistry/pediatric-dentist-in-guwahati.webp",
        "/dental-services/kids-dentistry/child-dentist-in-guwahati.webp"
      ],
      caption: "Images are for illustrative purposes only",
    },

    {
      type: "text",
      heading: "Our Kids Dental Services",
      content: `
We offer a wide range of preventive and treatment services tailored specifically for children:

✔ Dental Check-ups & Cleaning  
Regular check-ups and professional cleaning help remove plaque, prevent cavities, and keep your child’s teeth healthy. We also teach kids proper brushing techniques in a fun and easy way.

✔ Fluoride Gel Application  
Fluoride treatment helps strengthen enamel and protects teeth from decay—especially beneficial for cavity-prone children.

✔ Pulpotomy & Pulpectomy (Milk Tooth Treatment)  
When cavities reach the nerve of a baby tooth:  
Pulpotomy is done if the infection is limited  
Pulpectomy is required when the infection spreads deeper  
These procedures save the tooth until it naturally falls out, preventing pain and complications.

✔ Tooth Extraction in Children  
Some baby teeth may need to be removed due to severe decay, infection, trauma, or overcrowding. Child extractions are performed gently and painlessly under local anesthesia.

✔ Space Maintainers  
If a baby tooth is lost early, space maintainers help preserve the gap for permanent teeth, preventing misalignment and orthodontic problems later.

✔ Orthodontic Evaluation for Children  
Early orthodontic opinions help identify:  
Crooked or crowded teeth  
Jaw growth issues  
Bite problems  
Early intervention can reduce the need for braces later.

✔ Habit Counseling  
We guide parents and children on habits such as thumb sucking, mouth breathing, and nail biting that may affect dental development.
      `,
    },

    {
      type: "text",
      heading: "Is Kids Dental Treatment Painful?",
      content: `
No. Modern pediatric dentistry uses safe anesthesia and child-friendly techniques. Our dentists explain procedures in a simple, reassuring way to reduce fear and anxiety.

At **Magnum Dental Clinic**, we are patient, gentle, and attentive—because children need extra care.
      `,
    },

    {
      type: "text",
      heading: "When Should a Child Visit the Dentist?",
      content: `
Children should visit a dentist:

✔ By their first birthday  
✔ When their first tooth appears  
✔ Every 6 months for regular check-ups  
✔ If there is pain, swelling, cavities, or injury  

Early visits help create healthy dental habits and eliminate dental fear.
      `,
    },

    {
      type: "text",
      heading: "Why Choose Magnum Dental Clinic for Kids Dentistry in Guwahati?",
      content: `
✔ Child-friendly dental environment  
✔ Experienced dentists  
✔ Gentle and stress-free treatment  
✔ Preventive and advanced pediatric care  
✔ High hygiene and safety standards  
✔ Parent-focused counseling and education
      `,
    },
  ],

  faqs: [
    {
      q: "Are milk teeth really important?",
      a: "Yes. They guide permanent teeth and are essential for proper development.",
    },
    {
      q: "How often should kids brush their teeth?",
      a: "Twice daily using age-appropriate toothpaste.",
    },
    {
      q: "Can cavities in baby teeth be ignored?",
      a: "No. Untreated cavities can cause pain, infection, and affect permanent teeth.",
    },
    {
      q: "Is fluoride safe for children?",
      a: "Yes. Professional fluoride treatments are safe and effective when properly used.",
    },
  ],

  cta: {
    heading: "Book a Kids Dental Appointment in Guwahati",
    description: `
Healthy smiles start early. Give your child the gift of strong teeth and fearless dental visits.

📍 Location: First Floor, Global Tower, Near Mangalam Grand, Pathar Quarry, VIP Road, Guwahati, Assam

📞 Call at 8638940021 for consultation and pricing details

🧒🦷 Gentle care for little smiles.
    `,
    buttonText: "Book Kids Dental Appointment",
    link: "/book-appointment-dental-clinic-guwahati",
  },
};
